import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import fetch from 'cross-fetch';
import { createUploadLink } from 'apollo-upload-client';

const getApiURI = () => {
  return process.env.NODE_ENV === 'production'
    ? 'https://privatmegleren.no/nybygg/graphql'
    : process.env.NODE_ENV === 'staging'
    ? 'https://pmnybygg-staging.reeltime.no/graphql'
    : 'http://localhost:3000/graphql';
};

export const getAdminClient = () => {
  const link = createHttpLink({
    uri: getApiURI(),
    fetch: fetch,
  });
  const cache = new InMemoryCache();
  if (typeof window !== 'undefined') {
    cache.restore(window.__APOLLO_STATE__);
  }
  const client = new ApolloClient({
    name: 'privatmegleren_nybygg_client',
    link: link,
    cache: cache,
  });
  return client;
};

export const getUploadClient = () => {
  const link = createUploadLink({
    uri: getApiURI(),
    fetch: fetch,
  });
  const cache = new InMemoryCache();
  if (typeof window !== 'undefined') {
    cache.restore(window.__APOLLO_STATE__);
  }
  const client = new ApolloClient({
    name: 'privatmegleren_nybygg_client',
    link: link,
    cache: cache,
  });
  return client;
};
